import { render, staticRenderFns } from "./CardPayment.vue?vue&type=template&id=453dfcf1"
import script from "./CardPayment.vue?vue&type=script&lang=js"
export * from "./CardPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports